import React from "react";
import { AutocompleteInput, ReferenceInput } from "react-admin";
import { SchoolIdSelected } from "utils/tools";

const LevelInput = () => {
  return (
    <ReferenceInput
      label="Select Level"
      source="levelId"
      reference="levels"
      filter={{ SchoolId: Number(SchoolIdSelected()) }}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  );
};

export default LevelInput;
